import { request } from "service";
import endpoints from "service/endpoints";

export const getAllNotification = async (dispatch, params = {}, isLoad = true) => {
  try {
    isLoad && dispatch({ type: "SET_LOADER", payload: { isLoading: true } });
    let { data: { data, status } } = await request({
      url: endpoints.Endpoints.getAllNotification,
      method: endpoints.APIMethods.GET,
      baseUrl: "communication",
      params
    });
    if (status == 200) {
      dispatch({ type: "GET_ALL_NOTIFICATION", payload: { notifications: data } });
    }
  } catch (err) {
    console.log("err - ", err);
  } finally {
    isLoad && dispatch({ type: "SET_LOADER", payload: { isLoading: false } });
  }
};


export const markAsRead = async (dispatch, data = {}) => {
  try {
    let { data: { status } } = await request({
      url: endpoints.Endpoints.markAsRead,
      method: endpoints.APIMethods.POST,
      baseUrl: "communication",
      data,
      isShowMessage: false
    });
    // if (status == 200) getAllNotification(dispatch, {}, false);
    return true;
  } catch (err) {
    console.log("err - ", err);
  }
};
